import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

export const drawerOverlayVariants = cva('fixed inset-0 z-modalBackdrop', {
    variants: {
        overlayVariant: {
            default: 'bg-black/50',
            dark: 'bg-black/80',
        },
    },
    defaultVariants: {
        overlayVariant: 'default',
    },
});

export const DrawerOverlay = React.forwardRef<
    React.ElementRef<typeof DrawerPrimitive.Overlay>,
    React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Overlay> &
        VariantProps<typeof drawerOverlayVariants>
>(({ overlayVariant, className, ...props }, ref) => (
    <DrawerPrimitive.Overlay
        ref={ref}
        className={cn(drawerOverlayVariants({ overlayVariant, className }))}
        {...props}
    />
));

DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;
